import type { RouteRecordRaw } from "vue-router";

// const Info = () => import("@/pages/company/info.vue");
const InnoInfo = () => import("@/pages/company/innovadis/inno-info.vue");
const Members = () => import("@/pages/company/members.vue");

export const corporateRoutes: RouteRecordRaw[] = [
  { path: "info", name: "CompanyInfo", component: InnoInfo },
  { path: "members", name: "CompanyMembers", component: Members },
];
